<template>
<div>
    <user-address-info
    ref="refUserProfileInfo"
    :user-profile-id="userProfileId"
    :user-profiles-data="userProfilesData"
    />

    <company-info
    ref="refCompanyInfo"
    :user-profile-id="userProfileId"
    :user-profiles-data="userProfilesData"
    />

    <div class="align-center-bottom">
    <ejs-button
        type="button"
        cssClass="e-info margin-button"
        v-on:click.native="onSubmitUserProfileClick(false)"
        >Save Personal Details</ejs-button
    >
    </div>
</div>
</template>

<script>
import Vue from "vue";

import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";

import CompanyInfo from "./company-info.vue";
import UserAddressInfo from "./user-address-info.vue";

Vue.use(ButtonPlugin);

export default {
  name: 'ProfileInfoEdit',
  components: {
    CompanyInfo,
    UserAddressInfo,
  },
  props: {
    userProfileId: String,
    userProfilesData: Object,
  },
  data() {
    return {

    };
  },
  methods: {
    onSubmitUserProfileClick(hideNofificationMessage = false) {
      const userInfo = this.$refs.refUserProfileInfo;
      const companyInfo = this.$refs.refCompanyInfo;
      const phoneNumber = "1234455676";
      const invalidFields = [];
      let notificationContent = "";

      const { isFirstNameValid } = userInfo;
      const { isLastNameValid } = userInfo;
      const { isAddressValid } = userInfo;
      const { isCityNameValid } = userInfo;
      const { isPostalCodeValid } = userInfo;
      const { isCompanyValid } = companyInfo;

      const isFormValid = isFirstNameValid
                && isLastNameValid
                && isAddressValid
                && isCityNameValid
                && isPostalCodeValid
                && isCompanyValid;

      if (!isFirstNameValid) invalidFields.push("First Name");
      if (!isLastNameValid) invalidFields.push("Last Name");
      if (!isAddressValid) invalidFields.push("Address");
      if (!isCityNameValid) invalidFields.push("City Name");
      if (!isPostalCodeValid) invalidFields.push("Postal Code");
      // if (!isCompanyValid) invalidFields.push("Company Name");

      companyInfo.companyData();
      if (isFormValid) {
        userInfo.userProfile(phoneNumber);
        if (!hideNofificationMessage) {
          notificationContent = "User profile updated successfully.";
        }
      } else {
        userInfo.validateUserInfo();
        notificationContent = `Please enter value in required fields.<br><ul><li>${invalidFields.join(
          "</li><li>",
        )}</li></ul>`;
      }
      if (notificationContent) {
        this.showNotification(invalidFields, notificationContent);
      }
      return isFormValid;
    },
    showNotification(invalidFields, content) {
      const parent = this.$parent.$parent;
      const notificationObj = {
        content,
        timeOut: 5000,
      };
      if (invalidFields.length === 0) {
        notificationObj.cssClass = "e-toast-success";
        notificationObj.title = "Success!";
      } else {
        notificationObj.cssClass = "e-toast-danger";
        notificationObj.title = "Error!";
      }
      parent.notificationToasts.push(notificationObj);
      parent.$refs.notifierRef.show();
    },
  },
};
</script>

<style>

</style>
